<template>
  <div style="margin-bottom: 32px">
    <div class="banner">
      <img src="@/assets/banner.svg" />
    </div>
    <div class="nav" style="width: 100%;min-width: 1400px;">
      <div>
        <div
          @mouseenter="currIndex = index"
          @mouseleave="currIndex = -1"
          :class="
            item.query.id == $route.query.id && $route.path === item.path ? 'cover' : ''
          "
          v-for="(item, index) in navList"
          style="position: relative"
        >
          <div
            @click="jump(item)"
            style="
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            {{ item.title }}
          </div>

          <div style="position: absolute" class="xl" v-if="index === currIndex">
            <li v-for="i in item.children" @click="jump(i, item)">
              {{ i.title }}
            </li>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currIndex: -1,
      list: [],
      navList: [
        {
          title: "网站首页",
          path: "/",
          query: {},
        },
        {
          title: "期刊介绍",
          path: "/detail",
          query: {
            id: 12826,
            channelId: 12826,
            title: "期刊介绍",
          },
          children: [
            {
              title: "编委会",
              path: "/detail",
              query: {
                channelId: 12837,
                id: 159108,
              },
            },
            {
              title: "编辑部成员",
              path: "/detail",
              query: {
                channelId: 12838,
                id: 159111,
              },
            },
            {
              title: "期刊简介",
              path: "/detail",
              query: {
                channelId: 12839,
                id: 159110,
              },
            },
          ],
        },
        {
          title: "投稿指南",
          path: "/detail",
          query: {
            id: 12827,
            channelId: 12827,
            title: "投稿指南",
          },
          children: [
            {
              title: "编委会",
              path: "/detail",
              query: {
                channelId: 12837,
                id: 159108,
              },
            },
            {
              title: "编辑部成员",
              path: "/detail",
              query: {
                channelId: 12838,
                id: 159111,
              },
            },
            {
              title: "期刊简介",
              path: "/detail",
              query: {
                channelId: 12839,
                id: 159110,
              },
            },
          ],
        },
        // {
        //   title: "订阅信息",
        //   path: "/detail",
        //   query: {
        //     id: 159070,
        //     channelId: 12828,
        //     title: "订阅信息",
        //   },
        // },
        {
          title: "联系我们",
          path: "/detail",
          query: {
            id: 12852,
            channelId: 12852,
            title: "联系我们",
          },
          children: [
            {
              title: "联系方式",
              path: "/detail",
              query: {
                channelId: 12829,
                id: 159071,
              },
            },
            {
              title: "订阅信息",
              path: "/detail",
              query: {
                channelId: 12828,
                id: 159070,
              },
            },
          ],
        },
        {
          title: "创刊40周年",
          path: "/list",
          query: {
            id: 12844,
            channelId: 12844,
            title: "创刊40周年",
            type: true,
          },
          children: [],
        },
        {
          title: "English",
          path: "/enIndex",
          query: {
            id: 0,
          },
        },
      ],
      listAry: ["12849", "12847", "12846", "12856"],
    };
  },
  methods: {
    getNavList(channeID, title) {
      this.$post("JournalInfoApi/GetSiteContentPageList", {
        channeID: channeID,
        curr: 1,
        limit: 10,
        pChanneID: 0,
      }).then((res) => {
        let children = res.data.map((item) => {
          if (this.listAry.indexOf(item.linkUrl) != -1) {
            return {
              title: item.title,
              path: "/list",
              query: {
                channelId: item.linkUrl,
                type: true,
              },
            };
          } else {
            return {
              title: item.title,
              path: "/detail",
              query: {
                channelId: item.linkUrl,
              },
            };
          }
        });
        this.navList.filter((item) => {
          if (item.title === title) {
            item.children = children;
          }
        });
      });
    },

    jump(item, parent) {
      if (item.path && !item.children) {
        this.$router.push({
          path: item.path,
          query: {
            ...item.query,
            title: item.title,
            parentId: parent?.query.id,
            type: true,
          },
        });
      }
    },
  },
  created() {
    this.getNavList(12844, "创刊40周年");
    this.getNavList(12827, "投稿指南");
    this.getNavList(12826, "期刊介绍");
    this.getNavList(12852, "联系我们");
  },
};
</script>

<style lang="less" scoped>
.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 1400px;
  height: 300px;
  background: url("@/assets/bannerBg.png");
  img {
    height: 160px;
  }
}
.nav {
  display: flex;
  justify-content: center;
  height: 48px;
  background: #e4e0d5;
  > div {
    display: flex;
    width: 1400px;
    justify-content: space-between;
    > div {
      width: 144px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFang SC;
      font-size: 18px;
      font-weight: 600;
      align-items: center;
      color: #000000;
      cursor: pointer;
    }
    > div:hover {
      color: #00326a;
    }
    .cover {
      background-color: #00326a;
      color: #ffffff !important;
    }
  }
}

.xl {
  position: absolute;
  background-color: #fff;
  /* 自动布局子元素 */
  position: static;
  border-radius: 0px 0px 4px 4px;
  opacity: 1;
  box-shadow: inset 0px -1px 0px 0px #e8e8e8;
  z-index: 999;
  top: 48px;
  li {
    list-style: none;
    padding: 4px 16px;
    box-shadow: inset 0px -1px 0px 0px #e8e8e8;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 36px;
    text-align: center;
    letter-spacing: 0px;
    color: #333333;
    white-space: nowrap;
  }
  li:hover {
    background-color: #edf4ff;
  }
}
</style>
